import React, { useState } from "react";
import { API } from "@/lib/api";
import { Share2, Copy, Check, Mail, MessageCircle, Send } from "lucide-react";
import { toast } from "sonner";

const XIcon = (p) => <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.9l-5.4-7.06L3.9 22H.64l8.02-9.17L.5 2h7.07l4.88 6.45L18.244 2Zm-1.21 18h1.8L7.04 3.9H5.1L17.03 20Z" /></svg>;

export const ShareBar = ({ share, siteId, compact = false }) => {
  const [copied, setCopied] = useState(false);
  if (!share) return null;
  const copy = async () => {
    try { await navigator.clipboard.writeText(share.url); setCopied(true); toast.success("Campaign link copied"); setTimeout(() => setCopied(false), 1800); }
    catch { toast.error("Copy failed — long-press the link instead"); }
  };
  const btn = "inline-flex items-center gap-1.5 border border-white/10 px-2.5 py-1.5 text-xs hover:border-[#F472B6] hover:text-[#F472B6] transition-colors";
  return (
    <div className={`flex flex-wrap items-center gap-2 ${compact ? "" : "bg-[#050A15] border border-white/5 p-3"}`} data-testid="share-bar">
      {!compact && <span className="text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1 mr-1"><Share2 className="h-3 w-3" /> Share this campaign</span>}
      <button data-testid="share-copy" onClick={copy} className={btn}>{copied ? <Check className="h-3.5 w-3.5 text-[#00FF7F]" /> : <Copy className="h-3.5 w-3.5" />} Copy link</button>
      <a data-testid="share-x" href={share.x} target="_blank" rel="noreferrer" className={btn}><XIcon className="h-3.5 w-3.5" /> X</a>
      <a data-testid="share-whatsapp" href={share.whatsapp} target="_blank" rel="noreferrer" className={btn}><MessageCircle className="h-3.5 w-3.5" /> WhatsApp</a>
      <a data-testid="share-telegram" href={share.telegram} target="_blank" rel="noreferrer" className={btn}><Send className="h-3.5 w-3.5" /> Telegram</a>
      <a data-testid="share-email" href={share.email} className={btn}><Mail className="h-3.5 w-3.5" /> Email</a>
      {!compact && <img src={`${API}/social-housing/sites/${siteId}/share/qr.png`} alt="Campaign QR" className="h-14 w-14 ml-auto border border-white/10 bg-white p-0.5" data-testid="share-qr" />}
    </div>
  );
};
